import { render, staticRenderFns } from "./type.vue?vue&type=template&id=888f1dfc&scoped=true&"
import script from "./type.vue?vue&type=script&lang=ts&"
export * from "./type.vue?vue&type=script&lang=ts&"
import style0 from "./type.vue?vue&type=style&index=0&id=888f1dfc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "888f1dfc",
  null
  
)

export default component.exports